import React from "react";
import { Grid, InputLabel } from "@material-ui/core";
import Create from "@material-ui/icons/Create"

import avatar from "../../assets/img/faces/765-default-avatar.png";
import UserLinks from "./UserLinks";


//  editInput(event){
//   event.preventDefault();
//   console.log("Button clicked")
//   // inputProps={{
//   //   disabled: true
//   // }}
// }

function UserProfile({ ...props }) {
  // const { onChange } = props;
  // const { inputProps } = props;
 //const editInput = e =>{
  //console.log("Button clicked")
  // this.setState = {
  //   inputProps: enabled
  // }
 //}
  return (  
    <div>
      <UserLinks />
    </div>
  );
}


export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx